export enum ImageType {
    Original = 0,
    DefaultThumbnail = 1,
    FormsOverview = 2
}